<template>
  <div class="officer-form">
     <div class="title-info" v-if="!officerId">
      <div class="h1">{{ match.unionMatchName }}</div>
      <div class="h2">{{ team.name }}</div>
      <div class="item">
        允许工作人员数：{{ match.minOffice }} ～ {{ match.maxOffice }}
      </div>
    </div>
    <van-form ref="officerForm" input-align="right" error-message-align="right">
      <div class="title">
        <span>工作人员信息</span>
        <van-button
          v-if="officerId && !isEditMode"
          class="officer-form-edit-btn"
          plain
          @click="enterEditMode"
        >编辑</van-button>
      </div>
      <van-field
        label="姓名"
        v-model="officer.name"
        placeholder="请输入姓名"
        :readonly="formReadonly"
        :rules="formReadonly ? [] : [rulesWay('请输入名称')]"
      ></van-field>
      <!-- <van-field label="照片" :rules="[rulesWay('照片不能为空')]">
        <template #input>
          <van-uploader v-model="officer.avatarList" max-count="1" :after-read="uploadAvatar2"
            @delete="deleteAvatar2" />
        </template>
      </van-field> -->
      <div class="my-field" v-if="teamOfficersAvatarRequired === 1">
        <van-uploader
          v-if="!formReadonly"
          max-count="1"
          :preview-image="false"
          :after-read="uploadAvatar2"
          @delete="deleteAvatar2"
        >
          <div class="class-logo">
            <div class="img">
              <img src="@/assets/player-default.png" v-if="!officer.avatar" />
              <img :src="imageView(officer.avatar)" v-else />
            </div>
            <div class="logo-info">
              <div class="title2">报名照</div>
              <div class="desc">请上传用户报名照</div>
            </div>
            <van-icon name="arrow" class="icon" />
          </div>
        </van-uploader>
        <div v-else class="class-logo">
          <div class="img">
            <img src="@/assets/player-default.png" v-if="!officer.avatar" />
            <img :src="imageView(officer.avatar)" v-else />
          </div>
          <div class="logo-info">
            <div class="title2">报名照</div>
            <div class="desc">{{ officer.avatar ? '已上传' : '-' }}</div>
          </div>
        </div>
      </div>
      <van-field
        v-if="teamOfficersCertRequired === 1"
        label="证件号码"
        v-model="officer.certNo"
        placeholder="请输入身份证号码"
        :readonly="formReadonly"
        :rules="formReadonly ? [] : [rulesWay('请输入身份证号码')]"
      ></van-field>

      <van-field v-if="!formReadonly" label="性别" v-model="officer.gender" :rules="[rulesWay('请选择性别')]">
        <template #input>
          <van-radio-group v-model="officer.gender" direction="horizontal">
            <van-radio :disabled="checkIDCardNoDis(officer.certNo)" name="1" checked-color="#FF6010" icon-size="16px">男</van-radio>
            <van-radio :disabled="checkIDCardNoDis(officer.certNo)" name="2" checked-color="#FF6010" icon-size="16px">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-else label="性别" readonly :value="formatGender(officer.gender)" />

      <van-field
        v-if="!formReadonly"
        label="职务"
        v-model="officer.role"
        placeholder="请选择职务"
        readonly
        clickable
        @click="showRolesFun"
        :rules="[rulesWay('请选择职务')]"
      ></van-field>
      <van-field v-else label="职务" readonly :value="officer.role || '-'" />

      <van-field
        label="联系方式"
        v-model="officer.mobile"
        placeholder="请输入联系方式"
        :readonly="formReadonly"
        :rules="formReadonly ? [] : [rulesWay('请输入联系方式')]"
      ></van-field>

      <van-field
        v-if="match.sportType === '足球' && (officer.role === '教练' || officer.role === '主教练')"
        label="证书等级"
        v-model="officer.certificateTypeText"
        placeholder="请选择证书等级"
        readonly
        :clickable="!formReadonly"
        @click="formReadonly ? null : (showClass = true)"
        :rules="formReadonly ? [] : [rulesWay('请选择证书等级')]"
      ></van-field>
    </van-form>
    
    <div style="height: 80px;"></div>
    <div class="bottom" :class="{ 'only-right': (!officerId || isEditMode) && !(officerId && !isEditMode) }">
      <!-- 查看态：仅删除 -->
      <div v-if="officerId && !isEditMode" class="left" @click="deleteOfficer">
        <div class="img">
          <img src="@/assets/images/delete-icon.png" />
        </div>
        <div>删除</div>
      </div>
      <!-- 创建态/编辑态：仅保存 -->
      <div
        v-if="!officerId || isEditMode"
        class="right"
        @click="saveOfficer"
        :style="{'background-color':jetlympic? '#00A7FF': 'var(--bg3)' }"
      >提 交</div>
    </div>

    <!-- 弹窗组件 -->
    <van-popup v-model="showRoles" position="bottom" :style="{ height: '50%' }">
      <van-picker title="请选择角色" show-toolbar :columns="roleColumns" @confirm="onConfirm" @cancel="onCancel"
        :default-index="defaultIndex" />
    </van-popup>
    
    <van-popup v-model="showClass" round position="bottom" :style="{ height: '50%' }">
      <van-cascader :options="optionsClass" @close="showClass = false" v-model="certificateTypeText"
        @finish="finishClass" />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Form, Field, Popup, Cascader, RadioGroup, Radio, Button, Picker, Uploader, Toast, Dialog
} from "vant";
import { RegExpr, ToolUtil } from '@/utils'
import { getQiniuUploadToken, uploadImage } from '@/api/qiniu'
import {
  createBMMatchTeamOffice,
  updateBMMatchTeamOffice,
  getBMMatchTeamSignup,
  getBMMatchTeamOffice,
  deleteBMMatchTeamOffice
} from "@/api/match";
import { QNImageUtil } from '@/utils'
import { feeMethodOptions } from "@/config"

Vue.use(Form).use(Field).use(Popup).use(RadioGroup).use(Radio).use(Button)
  .use(Picker).use(Cascader).use(Uploader)
  .use(Dialog)
export default {
  name: 'OfficerForm',
  data() {
    return {
      officer: {},
      showRoles: false,
      defaultIndex: 0,
      showClass: false,
      certificateTypeText: [],
      qiniuToken: '',
      optionsClass: [
        {
          text: '十一人制足球教练员',
          value: 1,
          children: [
            { text: 'E级', value: 1 },
            { text: 'D级', value: 2 },
            { text: 'C级', value: 3 },
            { text: 'B级', value: 4 },
            { text: 'A级', value: 5 },
            { text: '职业级(PRO)', value: 6 },
          ],
        },
        {
          text: '五人制足球教练员',
          value: 2,
          children: [
            { text: '初级', value: 7 },
            { text: 'L1', value: 8 },
            { text: 'L2', value: 9 },
            { text: 'L3', value: 10 },
            { text: '职业级(PRO)', value: 11 },
          ]
        },
        {
          text: '社体指导员(足球)',
          value: 3,
          children: [
            { text: '5级(初级)', value: 12 },
            { text: '4级(中级)', value: 13 },
            { text: '3级(高级)', value: 14 },
            { text: '2级(指导师)', value: 15 },
          ]
        }
      ],
      unionMatchId: '',
      matchId: '',
      teamId: '',
      officerId: '',
      /** 编辑状态（有 officerId 时：false=查看显示编辑按钮，true=编辑显示保存按钮） */
      isEditMode: false,
      teamOfficersCertRequired: 0,
      teamOfficersAvatarRequired: 0,
      match: {},
      showButton: true,
      roleColumns: [],
      type: 'create',
      team: {},
      jetlympic: false
    };
  },
  computed: {
    /** 有 officerId 时默认查看，只读；点编辑后可编辑 */
    formReadonly() {
      return !!this.officerId && !this.isEditMode
    }
  },
  watch: {
    'officer.certNo': {
      handler() {
        if (RegExpr.isIdCard(this.officer.certNo)) {
          const officer = JSON.parse(JSON.stringify(this.officer))
          officer.gender = '' + ToolUtil.getSex(officer.certNo)
          this.officer = officer
        }
      }
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
     this.unionMatchId = this.$route.query.unionMatchId
    this.matchId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    if (this.$route.query.officerId && this.$route.query.officerId !== 'undefined') { 
      this.officerId = this.$route.query.officerId
    }
    if (this.officerId) {
      this.type = 'edit'
      setTimeout(() => {
        this.getBMMatchTeamOffice()
      }, 10)
    }
    this.getBMMatchTeamSignup()
    this.getQiniuUploadToken()
  },
  methods: {
    enterEditMode() {
      this.isEditMode = true
    },
    formatGender(gender) {
      if (gender === '1' || gender === 1) return '男'
      if (gender === '2' || gender === 2) return '女'
      return '-'
    },
     getFeeMethodsLabel(value) {
      const item = feeMethodOptions.find(f => f.value === value)
      if (!item) return '--'
      return item.label
    },
    getBMMatchTeamOffice() {
      getBMMatchTeamOffice({
        unionMatchId: this.unionMatchId,
        matchId: this.matchId,
        teamId: this.teamId,
        id: this.officerId
      }).then(res => { 
        if (res) {
          const { data } = res
          this.officer = data
          this.officer.avatarList = [{ url: QNImageUtil.imageView(data.avatar), isImage: true }]

           if (this.officer.certificateType) {
          let name = this.optionsClass.find(item => item.value === this.officer.certificateType)
          let name2 = name.text + '/' + name.children.find(item => item.value === this.officer.certificateLevel).text
          this.officer.certificateTypeText = name2
        }
        }
      })
    },
    // 初始化工作人员数据
    getBMMatchTeamSignup() {
      getBMMatchTeamSignup({
        unionMatchId: this.unionMatchId,
        matchId: this.matchId,
        teamId: this.teamId
      }).then(res => {
        if (res) {
          // this.officer = res.data
          const { data } = res
          this.match = data.match
          this.team = data.team
          if (data.match.teamOfficers) {
            this.roleColumns = data.match.teamOfficers.split(',') || []
          }
          this.teamOfficersCertRequired = this.match.teamOfficersCertRequired
          this.teamOfficersAvatarRequired = this.match.teamOfficersAvatarRequired
          console.log(data);
          
        }
      })
    },
    // 获取七牛云上传token
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },

    // 上传头像
    uploadAvatar2(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.officer.avatar = res.hash
        this.$forceUpdate()
      })
    },
    deleteOfficer() {
      Dialog.confirm({
        title: '标题',
        message: '确定删除该工作人员吗？',
      }).then(() => {
        deleteBMMatchTeamOffice({
          id: this.officerId
        }).then(res => {
          if (res) {
            Toast.success('删除成功')
            this.$router.back()
          }
        })
      })
    },
    // 删除头像
    deleteAvatar2() {
      this.officer.avatar = ''
      this.$set(this.officer, 'avatarList', [])
    },

    // 验证规则
    rulesWay(message) {
      return { required: true, message }
    },

    // 验证身份证号
    checkIDCardNoDis(value) {
      return RegExpr.isIdCard(value)
    },

    // 验证手机号
    checkMobile(value) {
      return RegExpr.checkMobile(value)
    },

    // 显示职务选择
    showRolesFun() {
      const index = this.roleColumns.findIndex(item => item === this.officer.role)
      this.defaultIndex = index > -1 ? index : 0
      this.showRoles = true
    },

    // 确认职务选择
    onConfirm(value) {
      this.officer.role = value
      this.showRoles = false
    },

    // 取消职务选择
    onCancel() {
      this.showRoles = false
    },

    // 完成证书等级选择
    finishClass({ selectedOptions }) {
      this.officer.certificateTypeText = `${selectedOptions[0].text}/${selectedOptions[1].text}`
      this.officer.certificateType = selectedOptions[0].value
      this.officer.certificateLevel = selectedOptions[1].value
      this.showClass = false
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    // 保存工作人员
    saveOfficer() {
      this.$refs.officerForm.validate().then(() => {
        if (this.type === 'edit') {
          if (this.officer.role !== '教练' && this.officer.role !== '主教练') {
            this.officer.certificateType = ''
            this.officer.certificateLevel = ''
          }
          const params = {
            ...this.officer
          }
          delete params.avatarList
          updateBMMatchTeamOffice(params).then(res => {
            if (res) {
              Toast.success('更新成功')
              this.$router.back()
              // this.$router.push({ path: '/entry-page/team-operate', query: { unionMatchId: this.unionMatchId, teamId:this.teamId,matchId:this.matchId, type: 'create-officer' } })
            }
          })
        } else {
          const params = {
            matchId: this.matchId,
            teamId: this.teamId,
            ...this.officer
          }
          delete params.avatarList
          createBMMatchTeamOffice(params).then(res => {
            if (res) {
              Toast.success('保存成功')
              this.$router.back()
              // this.$router.push({ path: '/entry-page/team-operate', query: { unionMatchId: this.unionMatchId, teamId:this.teamId,matchId:this.matchId, type: 'create-officer' } })
            }
          })
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
.officer-form {
  min-height: 100vh;
  background-color: #F6F6F6;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 43px;
  line-height: 43px;
  font-size: 16px;
  color: #909399;
  padding: 0 15px;
}
.officer-form-edit-btn {
  width: 68px;
  height: 30px;
  padding: 0;
  font-size: 13px;
  color: var(--bg3);
  background-color: #E9E9EB;
  border: none;
}
.bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100vw;
  padding: 12px 16px;
  padding-bottom: 22px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  &.only-right {
    justify-content: flex-end;
  }
  .right{
    width: 117px;
    height: 45px;
    border-radius: 69px;
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 45px;
    flex-shrink: 0;
  }
  .left{
      font-size: 11px;
      color: #3D3D3D;
      text-align: center;
      .img{
        width: 27px;
        height: 27px;
        background: #E3F1FF;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        margin-bottom: 3px;
        img{
          width: 14px;
          height: 14px;
        }
      }
    }
}
.title-info {
    background: #FFF;
    padding: 10px;
    position: relative;
    .h1{
      font-size: 14px;
      color: #333333;
    }
    .h2{
      font-size: 16px;
      color: #333333;
      margin-top: 10px;
    }
    .item{
      font-size: 12px;
      color: #666666;
      margin-top: 10px;
    }
    .price{
      position: absolute;
      right: 11px;
      bottom: 14px;
      font-size: 12px;
      color: #999999;
      font-weight: 500;

      span{
        font-size: 20px;
        color: #CC3232;
      }
    }
  }
::v-deep .van-cell{
  min-height: 54px;
  box-sizing: border-box;
  align-items: center;
}
::v-deep .van-field__label{
  color: rgba(0, 0, 0, 0.9);
}
::v-deep .van-field__control{
  font-weight: 500;
}
::v-deep .van-uploader{
  width: 100% !important;
}
::v-deep .van-uploader__wrapper{
  display: flex;
  justify-content: flex-end;
}
.my-field{
  width: 100%;
  background-color: #fff;
  // border-bottom: 1px solid #EEEEEE;
  ::v-deep .van-uploader__wrapper{
    display: block !important;
  }
  .class-logo{
    width: 100%;
    height: 74px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    box-sizing: border-box;
    .img{
      width: 48px;
      height: 48px;
      border-radius: 24px;
      background: #D8D8D8;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    .logo-info{
      margin-left: 8px;
      flex: 1;
      .title2{
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.9);
      }
      .desc{
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.4);
      }
    }
    .icon{
      color: #BDBDBD;
      font-size: 24px;
    }
  }
}
</style>
